export const VIEWS = {
  ARTICLE: "article",
  SEARCH: "search",
  ARTICLE_SEARCH: "article-search",
  MAIN: "main",
  SUBCATEGORY: "subcategory",
}

export const FEEDBACK_COMMENT_FIELD = {
  REASON: "comment",
  CUSTOM: "customComment",
}
